import { Link } from 'react-router-dom';
import React, { useCallback, useMemo } from 'react';
import { LogoSvg } from '@/components/ui';
import useLadyService from '@/services/LadyService';
import logoDarkScrolled from '@/assets/img/logo-scroll--dark.svg';
import logoLightScrolled from '@/assets/img/logo-scroll--light.svg';
import { useSelector } from 'react-redux';
import { getScrolledClass } from '@/stores/slices/headerSlice';
import { getUserCurrentCity } from '../../../stores/slices/userSlice';
import { useToggleCountryCZ } from '@/components/ui/select/SelectCountry';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';

const Logo = () => {
	const { theme, windowWidth, scrollToTop, t, region, lang } =
		useLadyService();

	const { resetFilter } = useFilterLogicContext();

	const currentCity = useSelector(getUserCurrentCity);

	const postAltLogo = useMemo(
		() =>
			t('altlogo', {
				City: currentCity?.title,
				Country: region,
			}),
		[currentCity, region, t],
	);

	const scrolledClass = useSelector(getScrolledClass);
	const toggleCountry = useToggleCountryCZ();

	const handleLogo = () => {
		resetFilter(true);
		toggleCountry();

		if (scrolledClass) {
			scrollToTop();
		}
	};

	const getThemeForLogo = useCallback(() => {
		if (theme === 'dark') {
			return logoDarkScrolled;
		} else {
			return logoLightScrolled;
		}
	}, [theme]);

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	const mainUrl = useMemo(() => {
		let url = `/${lang}/czechia`;
		if (lang === 'en') {
			url = '/';
		}
		if (isJsdom) {
			if (lang === 'en') {
				url = '/';
			} else {
				url = `/${lang}/czechia`;
			}
		}

		return url;
	}, [lang, isJsdom]);

	return (
		<Link
			to={mainUrl}
			title={t('titlelogo', {
				City: currentCity?.title,
				Country: region,
			})}
			className={'logo' + (isJsdom ? ' ssr' : '')}
			onClick={() => handleLogo()}
		>
			{scrolledClass === ' _scroll' && windowWidth > 767.98 ? (
				<img
					src={getThemeForLogo()}
					alt={postAltLogo}
				/>
			) : (
				<LogoSvg alt={postAltLogo} />
			)}
		</Link>
	);
};

export default Logo;
